import { ControlValueAccessor, UntypedFormControl } from '@angular/forms';
import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'vm-input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss'],
})
export class InputRadioComponent implements ControlValueAccessor {
  @Input() public isChecked: boolean;
  @Input() public productId: string;
  @Input() public alt: string;
  @Output() public optionClick?: EventEmitter<string> = new EventEmitter();

  @Input() public name: string;
  public onChange: (value: any) => { [key: string]: any };
  private onTouched: () => { [key: string]: any };
  public radioControl = new UntypedFormControl();
  public selectedProductId: string;

  constructor() {}

  public writeValue(value: any): void {
    this.isChecked = value;
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public click(productId: string): void {
    this.selectedProductId = productId;
    this.optionClick.emit(this.selectedProductId);
    if (this.onChange) {
      this.onChange(this.selectedProductId);
      this.onTouched();
    }
  }
}
